import PlanPicker from './PlanPicker';
import PlanCustomerPortal from './PlanCustomerPortal';
import StarterTrialExpired from './StarterTrialExpired';

export default function Plan({ blog, blogId, paymentSuccess }) {
  const { plan, expiryDate, hostingTrialExpiryDate, isCancelled } = blog;

  // Starter plan with expired hosting trial - show upgrade prompt
  // Use hostingTrialExpiryDate for Starter plan hosting status
  if (
    plan === 'starter' &&
    hostingTrialExpiryDate &&
    new Date(hostingTrialExpiryDate) < new Date()
  ) {
    return <StarterTrialExpired blogId={blogId} />;
  }

  // Regular trial (free users) or expired Basic/Pro/VIP - show plan picker
  if (plan === 'trial' || new Date(expiryDate) < new Date()) {
    return <PlanPicker blogId={blogId} />;
  }

  return (
    <PlanCustomerPortal
      paymentSuccess={paymentSuccess}
      plan={plan}
      blogId={blogId}
      isCancelled={isCancelled}
      expiryDate={expiryDate}
      hostingTrialExpiryDate={hostingTrialExpiryDate}
    />
  );
}
